import { Outlet } from 'react-router-dom';

/**
 * AuthLayout — bare passthrough for unauthenticated pages.
 * LoginPage manages its own full-screen split layout.
 */
export const AuthLayout = () => <Outlet />;
